import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "default-minus",
  "use": "default-minus-usage",
  "viewBox": "0 0 50 5",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 5\" id=\"default-minus\"><path d=\"M0 0h50v5H0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol